module.exports = __webpack_public_path__ + "static/2-23c0a015583b88d7927246c2e2c978f2.mp4";